import { useUserStore } from '~/store/useUserStore'
import { useRolesAccesses } from '~/features/useRolesAccesses'
import { Role } from '~/model/enums/Role'

const ROUTES_AVAILABLE_FOR_ALL = new Set([
    'index',
    'auth',
    'reset',
    'userresetpassword',
    'orders-id',
    'assemblies-id',
    'notifications',
])

const PRODUCT_MANAGEMENT_ROLES = [Role.SUPERADMIN, Role.DEVELOPER, Role.ADMIN]
const PRODUCT_MANAGEMENT_ROUTES = new Set([
    'products-edit-id',
])

export default defineNuxtRouteMiddleware((to) => {
    const { role } = useUserStore()
    const { menuItems } = useRolesAccesses()

    if (to.path === '/' && role === Role.DRIVER) {
        return navigateTo('/orders/current')
    }

    const hasMenuAccess = unref(menuItems)
        ?.find(item => item.to === to.path || item.children
            ?.find(child => child.to === to.path))

    const hasProductManagementAccess = PRODUCT_MANAGEMENT_ROUTES.has(String(to.name)) &&
        PRODUCT_MANAGEMENT_ROLES.includes(unref(role))

    if (
        !hasMenuAccess &&
        !ROUTES_AVAILABLE_FOR_ALL.has(String(to.name)) &&
        !hasProductManagementAccess
    ) {
        console.error('Доступ к этой странице для данной роли запрещен', {
            role: unref(role),
            route: to.path,
        })

        return navigateTo('/')
    }
})
